var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32,90.14641h10.07953c5.37143,0,8.52137,2.8512,8.52137,7.69234c0,4.60868-3.08366,7.32777-8.28936,7.32777h-5.0064v8.68708H32V90.14641z M41.74811,101.22069c2.3872,0,3.68022-1.22675,3.68022-3.48137c0-2.25463-1.22674-3.38194-3.64708-3.38194h-4.47611v6.86331H41.74811z M54.64984,90.14641h8.78651c7.49348,0,11.83702,4.31039,11.83702,11.77074c0,7.5929-4.37668,11.93645-12.00273,11.93645h-8.62079V90.14641z M63.53577,109.64262c4.04525,0,6.20045-2.68549,6.20045-7.65919c0-4.94057-2.18834-7.62605-6.23359-7.62605h-3.54765v15.28525H63.53577z M79.65372,90.14641H96v4.27725H84.95887v6.26674h8.52136v4.14468h-8.52136v9.01851h-5.30515V90.14641z M141.81494,16H60v56H16v60h44v44h112V50.49707L141.81494,16z M144,30.64569L159.18494,48H144V30.64569z M24,80h80v44H24V80z M68,168v-36h44V72H68V24h68v32h28v112H68z",
    fill: "#007bc0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfBlue);
export default __webpack_public_path__ + "static/media/pdfBlue.ce82e82002605811858782a97367267b.svg";
export { ForwardRef as ReactComponent };